import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DatabaseService} from "../../services/database/database.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Database} from "../../models/database";
import {DatabaseModal} from "../../modals/database-modal/database-modal.component";
import {ProjectService} from "../../services/project/project.service";
import {ToastrService} from "ngx-toastr";
import {MessagesService} from "../../services/messages/messages.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-databases',
    templateUrl: './databases.component.html',
    styleUrls: ['./databases.component.scss']
})
export class DatabasesComponent implements OnInit {

    @Input() projectId: string;
    @Input() databaseId: string;
    @Output() goBack = new EventEmitter();

    databases: Array<Database> = [];

    constructor(
        private modalService: NgbModal,
        private projectService: ProjectService,
        private databaseService: DatabaseService,
        private messagesService: MessagesService,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.loadDatabases();

        this.projectService.onSelect.subscribe(
            projectId => {
                this.projectId = projectId;
                this.databaseId = null;
                this.loadDatabases();
            },
            err => console.log(err)
        );

        this.databaseService.onChange.subscribe(
          _ => this.loadDatabases(),
            err => console.log(err)
        );
    }

    loadDatabases() {
        if (this.projectId)
            this.databaseService.getAllMyDatabases(this.projectId)
                .subscribe(
                    () => this.databases = this.databaseService.databases,
                    e => console.log(e));
    }

    onShowModal(projectId: string, database: Database = null, clone: boolean = false) {
        let modalRef;

        modalRef = this.modalService.open(DatabaseModal, {size: 'lg'});
        modalRef.componentInstance.projectId = projectId;
        modalRef.componentInstance.database = database;

        if (clone)
          modalRef.componentInstance.cloneDB = clone;
    }

    onSelect(databaseId: string) {
        this.router.navigate(['/projects/' + this.projectId + '/databases/' + databaseId]);
    }

    onClone(database: Database) {
        this.onShowModal(this.projectId, database, true);
    }

    onDelete(databaseId) {
        this.messagesService.confirmModal().result.then(
            result => {
                if (result)
                    this.databaseService.deleteDatabase(this.projectId, databaseId)
                        .subscribe(
                            () => this.messagesService.successToast('Database deleted.'),
                            err => this.messagesService.errorToast(err)
                        );
            }
        ).catch(() => {
        });
    }

}
